import React from 'react';

import E9ToolBar from '../ecology9/E9ToolBar';

class E8ToolBar extends React.Component {
  render() {
    return (
      <div className="e8header-toolbar">
        <E9ToolBar ecId={`${(this && this.props && this.props.ecId) || ''}_E9ToolBar@amwhxg`} />
      </div>
    );
  }
}

export default E8ToolBar;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8ToolBar.js